import React from "react";

import InquiryForm from "../InquiryForm";

const StudyInAustralia = () => {
  return (
    <div className="study-australia-container">

      {/* Hero Section */}
      <section className="hero-section">
        <div className="text-content">
          <h1>Study in Australia</h1>
          <p>
            Australia has emerged as one of the most favorable destinations for pursuing studies.
            The Australian education system promotes overall personality development while
            preparing students for successful careers. With over 400,000 international students
            from nearly 200 countries, Australia is one of the most prestigious study destinations
            in the world.
          </p>
        </div>

        <div className="image-content">
          <img
            src="https://images.unsplash.com/photo-1506973035872-a4f23ef3d5b5"
            alt="Study in Australia"
          />
        </div>
      </section>

      {/* About Section */}
      <section className="info-section">
        <div className="info-card">
          <h2>Global Recognition</h2>
          <p>
            Australia has seven universities in the world’s top 100 and ranks eighth in the
            U21 Ranking of National Higher Education Systems. Degrees from Australian
            institutions are recognized worldwide and highly valued by employers.
          </p>
        </div>

        <div className="info-card">
          <h2>Growing Destination</h2>
          <p>
            Australia is the third most popular destination for international students
            in the English-speaking world. Students choose Australia for its cultural
            diversity, friendly environment, and high-quality education system.
          </p>
        </div>

        <div className="info-card">
          <h2>Cost of Living & Scholarships</h2>
          <p>
            Living expenses and tuition fees in Australia are comparatively lower than
            in the United States and the United Kingdom. Students can work part-time
            (up to 20 hours per week) and may apply for scholarships to support their studies.
          </p>
        </div>

        <div className="info-card">
          <h2>Diversity of Education</h2>
          <p>
            With over 22,000 courses across 1,100 institutions, Australia offers
            universities, vocational education, foundation programs, and English language
            courses. Students can easily move between qualification levels and institutions.
          </p>
        </div>

        <div className="info-card">
          <h2>Technology & Research</h2>
          <p>
            Australia is at the forefront of scientific research and technological innovation.
            Students benefit from advanced research facilities and global academic excellence
            across Natural Sciences, Medicine, Pharmacy, Agriculture, and Engineering.
          </p>
        </div>

        <div className="info-card">
          <h2>Intakes</h2>
          <p>
            Australia generally has two major intakes: February and July.
            Some universities also offer additional intakes in September and November.
            Applications should ideally begin 7–8 months prior to the intake,
            and processing usually takes 4–6 weeks.
          </p>
        </div>
      </section>

      {/* Why Study Section */}
      <section className="why-section">
        <h2>Why Study in Australia?</h2>
        <ul>
          <li>High standard of living</li>
          <li>Globally recognized degrees</li>
          <li>Part-time work opportunities (20 hrs/week)</li>
          <li>Affordable tuition compared to US & UK</li>
          <li>Safe, friendly and multicultural society</li>
          <li>Five cities ranked among the world’s best student cities</li>
        </ul>
      </section>

      {/* Inquiry Form */}
      <InquiryForm title="Inquire About Study in Australia" />

    </div>
  );
};

export default StudyInAustralia;
